'use client';

import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Text } from '@mantine/core';
import { palettenext } from 'ui-lib/src/lib/color/palette-next';

import { containerStyle, expandedButtonInner, workspaceNameTextStyle } from './styles.css';

export function ExpandedButton(props: {
  toggleDropdown: () => void;
  avatarUrl?: string;
  initials: string;
  workspaceName: string;
  isOpen: boolean;
}) {
  return (
    <button className={containerStyle} onClick={props.toggleDropdown}>
      <div className={expandedButtonInner}>
        <Avatar
          src={props.avatarUrl}
          alt={props.workspaceName}
          color="red"
          bd="1px solid gray.1"
          radius="sm"
          size="md"
        >
          {props.initials}
        </Avatar>
        <Text fw={600} className={workspaceNameTextStyle} size="sm">
          {props.workspaceName}
        </Text>
      </div>
      <FontAwesomeIcon
        color={palettenext.neutral[500]}
        icon={props.isOpen ? faChevronUp : faChevronDown}
        size="sm"
      />
    </button>
  );
}
